import { FunctionComponent } from 'react';
import styles from './Tips.module.scss';
import TipsDetail from 'components/Payments/TipsDetail';

interface TipsProps {
    description?: string;
}

export const Tips: FunctionComponent<TipsProps> = props => {
    return (
        <div>
            <div className={styles.description}>{props.description}</div>
            <TipsDetail showTitle={false} />
        </div>
    );
};

export default Tips;
